// ... existing code ...

export function objectToParams(obj: Record<string, any>): string {
    const params = new URLSearchParams();

    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] != null) {
            if (typeof obj[key] === 'object') {
                params.append(key, JSON.stringify(obj[key]));
            } else {
                params.append(key, obj[key].toString());
            }
        }
    }

    return params.toString();
}

// ... existing code ...